__turbopack_context__.v({
  "container": "ClientAuthContainer-module-scss-module__zMXYQW__container",
});
